import { api } from "./api";

export const obtenerPersonalBibliotecarioPorCorreo = (correo) => {
  return api.get("/personalbibliotecario/findByCorreo", { params: { correo } });
};

export const registrarVoluntario = (personalBibliotecario) => {
  return api.post("/personalbibliotecario/registerVoluntario", personalBibliotecario);
};

export const registrarBibliotecario = (personalBibliotecario) => {
  return api.post("/personalbibliotecario/registerBibliotecario", personalBibliotecario);
};

export const obtenerVoluntariosPaginados = (page = 0, size = 10) => {
  return api.get("/personalbibliotecario/allVoluntarios", { params: { page, size } });
};

export const obtenerBibliotecariosPaginados = (page = 0, size = 10) => {
  return api.get("/personalbibliotecario/allBibliotecarios", { params: { page, size } });
};

export const habilitarPersonal = (id) => {
  return api.put(`/personalbibliotecario/habilitar/${id}`, {});
};

export const inhabilitarPersonal = (id) => {
  return api.put(`/personalbibliotecario/inhabilitar/${id}`, {});
};
